// extracted by mini-css-extract-plugin
export var contentBody = "_ac-9";
export var headerImage = "_ac-2";
export var imageButton = "_ac-7";
export var imageButtonIcon = "_ac-8";
export var imageHeader = "_ac-4";
export var imageHeaderText = "_ac-5";
export var imageOverlay = "_ac-3";
export var imageTitle = "_ac-6";
export var imageWrapper = "_ac-1";
export var taskList = "_ac-a";
export var widget = "_ac-0";